const { RECAPTCHA_KEY } = process.env;

export const getCaptcha = async (action) => {
  try {
    if (typeof window === 'undefined') return null;
    await new Promise((resolve) => window.grecaptcha.ready(() => resolve()));
    const recaptcha = await window.grecaptcha.execute(RECAPTCHA_KEY, {
      action,
    });
    return recaptcha;
  } catch (err) {
    return null;
  }
};
